<template>
  <v-navigation-drawer
    class="pt-5"
    width="500"
    :temporary="true"
    location="right"
    v-model="configTrigger"
    @update:modelValue="configTrigger = $event"
    :absolute="true"
    :scrim="true"
    :disable-resize-watcher="true"
    :disable-route-watcher="true"
  >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :label="$t('labels.name')"
            :hint="$t('labels.rename-mashup')"
            :persistent-hint="true"
            v-model="mashupProp.title"
            variant="outlined"
            type="text"
            density="default"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-combobox
            prefix="Tags"
            variant="outlined"
            density="default"
            :no-data-text="$t('labels.no-data-available')"
            :hint="$t('labels.mashup-tags')"
            :persistent-hint="true"
            :persistent-placeholder="true"
            v-model="mashupProp.tags"
            :items="mashupProp.tags"
            :chips="true"
            :closable-chips="true"
            :multiple="true"
            filled
            append-icon=""
          >
            <template v-slot:selection="{ props, item, select, selected }">
              <v-chip
                v-bind="props"
                :input-value="selected"
                size="small"
                density="default"
                @click="select"
                @click:close="remove(item)"
              >
                <strong>{{ item }}</strong>
                <template v-slot:append>
                  <v-icon>mdi-close-circle</v-icon>
                </template>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            :items="datamodels"
            :hint="$t('labels.datamodel-hint')"
            :persistent-hint="true"
            :no-data-text="$t('labels.no-data-available')"
            :placeholder="datamodels[0]"
            auto-select-first
            @change="change"
            density="default"
            variant="outlined"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" v-if="customFlag">
          <v-textarea
            :hint="$t('strings.json-schema-hint')"
            :persistent-hint="true"
            label="JSON schema"
            variant="outlined"
            :no-resize="true"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn color="secondary" class="text-white" @click="updateMashup">
            {{ $t("labels.save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import SidebarConfigure from "@/mixins/SidebarConfigure";
import utils from "@/mixins/utils";
import events from "@/mixins/events.js";

export default {
  name: "SidebarConfigure",
  mixins: [utils, events, SidebarConfigure],
  data() {
    return {
      datamodels: [],
    };
  },
  props: {
    drawerConfig: Boolean,
    customFlag: Boolean,
    mashupProp: {},
    mashupsEditorAppbarConfig: {},
    realm: String,
  },
  methods: {
    remove(item) {
      this.mashupProp.tags.splice(this.mashupProp.tags.indexOf(item), 1);
      this.mashupProp.tags = [...this.mashupProp.tags];
    },
    change(e) {
      this.customFlag = e === "Custom";
    },
  },
  computed: {
    configTrigger: {
      get() {
        return this.drawerConfig;
      },
      set(value) {
        this.$emit("update:drawerConfig", value);
      },
    },
  },
};
</script>

<style scoped>
.v-text-field__prefix {
  margin-right: 50px;
}

.v-navigation-drawer {
  box-shadow: none !important;
  height: calc(100% - 104px) !important;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
</style>
